import React from 'react'
import { Grid2, IconButton } from '@mui/material';
import MoreIcon from '@mui/icons-material/MoreHoriz'

const ItemFunctionDisplay = ( getItemOptions, item, handleClick ) => {
    const itemOptions = getItemOptions && getItemOptions(item)
    if (!itemOptions|| itemOptions.length === 0) {
        return;
    } else {
        return (
            <Grid2 style={{position: 'absolute', right: 0}}>
                <IconButton onClick={handleClick}>
                    <MoreIcon />
                </IconButton>
            </Grid2>
        )
    }
}

export default ItemFunctionDisplay
